
import { defineComponent } from 'vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import DepositsTable from '@/components/common/DepositsTable.vue';

export default defineComponent({
  name: 'DepositsTableDialog',

  components: {
    CustomDialog,
    DepositsTable
  },

  computed: {
    lastFour() {
      return this.$store.getters['Account/getBankAccountLastFour'];
    }
  }
});
